import { SelectItem } from '@wui/common-library'
import { computed, ComputedRef } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { useUserFeatures } from '@/shared/composables/user-features'
import { BlfTypes, FeaturesNames } from '@/shared/types/settings'

export const useSettingsTerminals = () => {
  const { t } = useLocalization()
  const { hasFeature } = useUserFeatures()

  const blfTypes: ComputedRef<SelectItem[]> = computed(() => {
    const map = new Map<BlfTypes, string>()
    map.set(BlfTypes.NOT_USED, t('common.dontUse'))
    map.set(BlfTypes.BLF_NO_PICKUP, t('common.numberControlWithoutInterception'))
    map.set(BlfTypes.LINE, t('common.phoneLineBinding'))
    if (hasFeature(FeaturesNames.BLF)) {
      map.set(BlfTypes.BLF, t('common.numberControl'))
    }
    map.set(BlfTypes.SPEED_DIAL, t('common.speedDial'))
    map.set(BlfTypes.EXTENSION_MOBILITY, t('common.extensionMobility'))
    return Array.from(map).map(([value, label], index) => {
      return {
        value,
        label,
        default: index === 0,
      }
    })
  })

  return {
    blfTypes,
  }
}
